export const GET_LIVE_TV = "GET_LIVE_TV";

export const GET_LIVE_TV_CREATE_BY_ADMIN = "GET_LIVE_TV_CREATE_BY_ADMIN"
// create live tv

export const CREATE_LIVE_TV = "CREATE_LIVE_TV";

// id-list
export const GET_ID_LIST = "GET_ID_LIST";


export const UPDATE_SINGLE_LIVE_TV = "UPDATE_SINGLE_LIVE_TV";

//  open dialogue

export const OPEN_LIVE_TV_DIALOGUE = "OPEN_LIVE_DIALOGUE";

// close dialogue
export const CLOSE_LIVE_TV_DIALOGUE = "CLOSE_LIVE_TV_DIALOGUE";


export const OPEN_LIVE_TV_ACTION_DIALOGUE = "OPEN_LIVE_TV_ACTION_DIALOGUE";

// close dialogue
export const CLOSE_LIVE_TV_ACTION_DIALOGUE = "CLOSE_LIVE_TV_ACTION_DIALOGUE";

export const OPEN_LIVE_TV_INFO_DIALOGUE = "OPEN_LIVE_TV_INFO_DIALOGUE";

// close dialogue
export const CLOSE_LIVE_TV_INFO_DIALOGUE = "CLOSE_LIVE_TV_INFO_DIALOGUE";



// get country

export const GET_COUNTRY = "GET_COUNTRY";

// edit liveTv channel  

export const EDIT_LIVETV_CHANNEL = "EDIT_LIVETV_CHANNEL";


// delete liveTv channel

export const DELETE_LIVETV_CHANNEL = "DELETE_LIVETV_CHANNEL"


export const GET_FLAG = "GET_FLAG"


// Programs
export const CREATE_PROGRAM_REQUEST = 'CREATE_PROGRAM_REQUEST';
export const CREATE_PROGRAM_SUCCESS = 'CREATE_PROGRAM_SUCCESS';
export const CREATE_PROGRAM_FAILURE = 'CREATE_PROGRAM_FAILURE';

//Update program
export const UPDATE_PROGRAM_REQUEST = 'UPDATE_PROGRAM_REQUEST';
export const UPDATE_PROGRAM_SUCCESS = 'UPDATE_PROGRAM_SUCCESS';
export const UPDATE_PROGRAM_FAILURE = 'UPDATE_PROGRAM_FAILURE';